import { Platform } from 'root/src/shared/@types/platforms';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
// Resolve a creator's public profile URL from their preferred platform token. Shared by the
// RedesignNavbar user menu and the command palette so both link to the same destination. Points
// straight at the platform-specific `/nova` profile (mirroring the legacy URL structure), so cohort
// users do not bounce through a legacy `/creators/<platform>/...` URL.
export const profileUrlFor = (platform, mnemonicId) => {
    if (!mnemonicId) {
        return undefined;
    }
    switch (platform) {
        case Platform.Twitch:
            return routeUrls.creatorsTwitchRedesign(mnemonicId);
        case Platform.YouTube:
            return routeUrls.creatorsYoutubeRedesign(mnemonicId);
        case Platform.TikTok:
            return routeUrls.creatorsTiktokRedesign(mnemonicId);
        default:
            return undefined;
    }
};
